//MISC

import { appRoutes } from "config/AppRoutesConfig";

//ASSETS
import OfficialAnnouncements from "assets/svg/ComunicateMob.svg";
import Agenda from "assets/svg/IllAgendaWeb.svg";
import NewsMob from "assets/svg/StiriParteneriMob.svg";
import RoundedQuarterCircle from "assets/svg/RoundedQuarterCircle.svg";
import KitMedia from "assets/svg/KitMediaWeb.svg";

//LIBRARY

import { useTranslation } from "react-i18next";
import { COLORS } from "constants/variables";

export enum TextPlacement {
  right = "right",
  left = "left",
}

export interface NewsAndMediaCard {
  id: number;
  title: string;
  backgroundColor: string;
  textColor: string;
  svg: string;
  svgPosition: { bottom?: string; left?: string; right?: string; top?: string };
  svgTransform?: string;
  svgOpacity?: number;
  route: string;
  gridArea: string;
  imgProps: string;
  textPlacement: TextPlacement;
}

export interface ImgProps {
  imgProps: string;
}

export const useNewsCards = (): NewsAndMediaCard[] => {
  const { t } = useTranslation();

  return [
    {
      id: 1,
      title: t("view.newsAndMedia.communications"),
      backgroundColor: COLORS.FaluRed,
      textColor: COLORS.Yellow,
      svg: OfficialAnnouncements,
      svgPosition: { bottom: "0", left: "0" },
      route: appRoutes.officials,
      gridArea: "officialAnnouncements",
      imgProps: "svg-officialAnnouncements",
      textPlacement: TextPlacement.left,
    },
    {
      id: 2,
      title: t("view.newsAndMedia.agenda"),
      backgroundColor: COLORS.Yellow,
      textColor: COLORS.RaisinBlack,
      svg: Agenda,
      svgPosition: { bottom: "10px" },
      route: appRoutes.agenda,
      gridArea: "agenda",
      imgProps: "svg-agenda",
      textPlacement: TextPlacement.right,
    },
    {
      id: 3,
      title: t("view.newsAndMedia.news"),
      backgroundColor: COLORS.FaluRed,
      textColor: COLORS.Cultured,
      svg: NewsMob,
      svgPosition: { right: "0", top: "0" },
      route: appRoutes.newsAndPartners,
      gridArea: "news",
      imgProps: "svg-news",
      textPlacement: TextPlacement.left,
    },
    {
      id: 4,
      title: t("view.newsAndMedia.calendar"),
      backgroundColor: COLORS.Yellow,
      textColor: COLORS.RaisinBlack,
      svg: RoundedQuarterCircle,
      svgPosition: { bottom: "0", left: "0" },
      svgTransform: "rotate(0.5turn)",
      svgOpacity: 0.35,
      route: appRoutes.events,
      gridArea: "events",
      imgProps: "svg-events",
      textPlacement: TextPlacement.left,
    },
    {
      id: 5,
      title: t("view.newsAndMedia.info"),
      backgroundColor: COLORS.FaluRed,
      textColor: COLORS.Cultured,
      svg: RoundedQuarterCircle,
      svgPosition: { top: "-5px", right: "0" },
      svgTransform: "rotate(1turn)",
      svgOpacity: 0.35,
      route: appRoutes.newsletter,
      gridArea: "info",
      imgProps: "svg-info",
      textPlacement: TextPlacement.left,
    },
    {
      id: 6,
      title: t("view.newsAndMedia.kit"),
      backgroundColor: COLORS.Yellow,
      textColor: COLORS.RaisinBlack,
      svg: KitMedia,
      svgPosition: { bottom: "-10px", right: "0" },
      route: "/assets/complex/kit-media.zip",
      gridArea: "kitMedia",
      imgProps: "svg-kitMedia",
      textPlacement: TextPlacement.left,
    },
  ];
};
